import * as React from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import { DialogActions, DialogContent, DialogTitle, Divider, Modal, ModalDialog } from '@mui/joy';

import Mails from '../components/email/Mails.tsx';
import ChangePasswordModal from '../components/auth/ChangePasswordModal.tsx';
import AnnouncementModal from '../components/AnnouncementModal.tsx';
import { useState } from 'react';
import { useMail } from '../contexts/Mail.tsx';
import { DeleteForever, WarningRounded, LogoutRounded, KeyRounded } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const { mail, logout } = useMail();
  const [emailCount, setEmailCount] = useState<number>(0);
  const [openDeleteAll, setOpenDeleteAll] = React.useState<boolean>(false);
  const [deleteAll, setDeleteAll] = React.useState<number>(0);
  const [openChangePassword, setOpenChangePassword] = React.useState<boolean>(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div>
      <AnnouncementModal />
      
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
        }}
      >
        <Box sx={{ alignItems: 'center', gap: 1, textAlign: { xs: 'center', sm: 'left' } }}>
          <Typography
            level="title-lg"
            textColor="text.secondary"
            component="h1"
            fontWeight="bold"
            sx={{ fontSize: { xs: '18px', sm: '24px' } }}
          >
            {mail}
          </Typography>
          <Typography
            level="title-sm"
            textColor="text.tertiary"
            sx={{ fontSize: { xs: '14px', sm: '16px' } }}
          >
            {emailCount} mails
          </Typography>
        </Box>
        <Box
          display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} mb={2}
        >
          <Box display="flex" gap={2}>
            <Button
              color="danger"
              endDecorator={<DeleteForever />}
              onClick={() => setOpenDeleteAll(true)}
            >
              Delete all
            </Button>
            <Button
              size="sm"
              color="neutral"
              endDecorator={<KeyRounded />}
              onClick={() => setOpenChangePassword(true)}
            >
              Change password
            </Button>
            <Button
              size="sm"
              color="danger"
              variant="outlined"
              endDecorator={<LogoutRounded />}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Modal xác nhận xóa toàn bộ mail */}
      <Modal open={openDeleteAll} onClose={() => setOpenDeleteAll(false)}>
        <ModalDialog variant="outlined" role="alertdialog">
          <DialogTitle>
            <WarningRounded />
            Confirmation
          </DialogTitle>
          <Divider />
          <DialogContent>
            Are you sure you want to delete all of your mails?
          </DialogContent>
          <DialogActions>
            <Button
              variant="solid"
              color="danger"
              onClick={() => {
                setDeleteAll(deleteAll + 1);
                setOpenDeleteAll(false);
              }}
            >
              Delete all mails
            </Button>
            <Button variant="plain" color="neutral" onClick={() => setOpenDeleteAll(false)}>
              Cancel
            </Button>
          </DialogActions>
        </ModalDialog>
      </Modal>

      {/* Component hiển thị danh sách email */}
      <Mails onMailCountUpdate={setEmailCount} deleteAll={deleteAll} />

      {/* Modal thay đổi mật khẩu */}
      <ChangePasswordModal 
        open={openChangePassword} 
        onClose={() => setOpenChangePassword(false)} 
      />
    </div>
  );
}
